import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { isValidators } from '../../../utils/ValidatorUtils'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { Col, FlexboxGrid } from 'rsuite'

export default function ManageDurableArticlesManageType({ schema, onApply = () => {}, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const onSubmit = (data) => {
    onApply(data)
  }

  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <FlexboxGrid>
          {schema.closureType && (
            <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
              <InputSelectForm
                schema={schema.closureType}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                skipValidate={true}
              />
            </FlexboxGrid.Item>
          )}
        </FlexboxGrid>

        <SaveButton
          style={{ marginTop: 10 }}
          icon="check-circle"
          children="นำไปใช้กับรายการที่เลือก"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </>
  )
}
